export const opportunitiesFilterables = [
  'client',
  'stage',
  'forecast',
  'account_manager_name',
  'key_person_names',
  'job_type_initials',
];
